import { useState, useCallback, useEffect } from 'react';
import { diagramToJson, parseDiagramJson } from './diagramUtils';   // ← replaces pdfUtils
import { fetchWithAuth } from '../../../utils/api';
import { BASE_DOCS_API_GET } from '../../Config/Config';


// ── Hook ──────────────────────────────────────────────────────────────────────
export function useFiles() {
  const [files, setFiles]               = useState([]);
  const [currentFileId, setCurrentFileId] = useState(null);
  const [draftFiles, setDraftFiles] = useState([]);
const [edmDocuments, setEdmDocuments] = useState([]);
 const [sessionUserData, setsessionUserData] = useState({});

 useEffect(() => {
         const userDataString = sessionStorage.getItem("userData");
         if (userDataString) {
             const userData = JSON.parse(userDataString);
             setsessionUserData(userData);
         }
      }, []);

  // ── helpers ────────────────────────────────────────────────────────────────

  /** Upsert a file entry in local state (no server call). */
  const saveFile = useCallback((id, name, nodes, connections) => {
    setFiles((prev) => {
      const idx     = prev.findIndex((f) => f.id === id);
      const existing = idx >= 0 ? prev[idx] : null;

      const file = {
        id,
        name,
        nodes,
        connections,
        updatedAt : Date.now(),
        filename  : existing?.filename || null,
        url       : existing?.url      || null,
      };

      return idx >= 0
        ? prev.map((f) => (f.id === id ? file : f))
        : [file, ...prev];
    });
  }, []);

  /** Create a blank file entry and return it. */
  const newFile = useCallback(() => {
    const id   = `f${Date.now()}`;
    const file = {
      id,
      name        : 'Untitled diagram',
      nodes       : [],
      connections : [],
      updatedAt   : Date.now(),
      filename    : null,
      url         : null,
    };
    setFiles((prev) => [file, ...prev]);
    setCurrentFileId(id);
    return file;
  }, []);

  const getFile = useCallback(
    (id) => files.find((f) => f.id === id) || null,
    [files],
  );

  const deleteFile = useCallback(
    (id) => {
      setFiles((prev) => prev.filter((f) => f.id !== id));
      if (currentFileId === id) {
        const remaining = files.filter((f) => f.id !== id);
        setCurrentFileId(remaining[0]?.id || null);
      }
    },
    [currentFileId, files],
  );

  // ── SAVE to server ─────────────────────────────────────────────────────────
  /**
   * Serialises the diagram to a .json file, uploads it, then calls
   * AddFlowChart so the server knows about it.
   *
   * Returns { upload, flowChart } on success, null on failure.
   */
  // const saveFileWithJson = useCallback(
  //   async (id, name, nodes, connections) => {
  //     // 1. Keep local state in sync first
  //     saveFile(id, name, nodes, connections);

  //     // 2. Build the JSON blob
  //     const jsonBlob = diagramToJson({ name, nodes, connections });
  //     const safeName = (name || 'diagram').replace(/[^a-zA-Z0-9_-]/g, '_');
  //     const formData = new FormData();
  //     formData.append('DocumentUrl', jsonBlob, `${safeName}.json`);

  //     try {
  //       // 3. Upload the file
  //       const uploadResponse = await fetch(JSON_UPLOAD_URL, {
  //         method : 'POST',
  //         body   : formData,
  //       });
  //       if (!uploadResponse.ok) throw new Error('JSON upload failed');

  //       const uploadData = await uploadResponse.json();

  //       // 4. Extract filename / url from whatever shape the server returns
  //       const fileName =
  //         uploadData?.filename        ||
  //         uploadData?.data?.filename  ||
  //         uploadData?.data?.FileName  ||
  //         uploadData?.data?.finename  ||   // keep your existing typo fallback
  //         null;

  //       const fileUrl =
  //         uploadData?.url             ||
  //         uploadData?.data?.url       ||
  //         uploadData?.data?.FileUrl   ||
  //         (fileName ? `${JSON_BASE_URL}${fileName}` : null);

  //       // 5. Persist url + filename back into local file list
  //       setFiles((prev) =>
  //         prev.map((f) =>
  //           f.id === id
  //             ? { ...f, filename: fileName, url: fileUrl, updatedAt: Date.now() }
  //             : f,
  //         ),
  //       );

  //       // 6. Register with AddFlowChart endpoint
  //       const addFlowChartResponse = await fetch(`${BASE_API}file_upload/FlowChart`, {
  //         method  : 'POST',
  //         headers : { 'Content-Type': 'application/json' },
  //         body    : JSON.stringify({ ImageUrl: fileName || fileUrl }),
  //       });
  //       if (!addFlowChartResponse.ok) throw new Error('AddFlowChart failed');

  //       const addFlowChartData = await addFlowChartResponse.json();

  //       return { upload: uploadData, flowChart: addFlowChartData };
  //     } catch (err) {
  //       console.error('saveFileWithJson error:', err);
  //       return null;
  //     }
  //   },
  //   [saveFile],
  // );

  // ── LOAD from server ───────────────────────────────────────────────────────
  
  
  const saveFileWithJson = useCallback(
    async (id, name, nodes, connections) => {
      saveFile(id, name, nodes, connections);
  
      const jsonBlob = diagramToJson({
        name,
        nodes,
        connections,
      });
  
      const safeName = (name || "diagram").replace(/[^a-zA-Z0-9_-]/g, "_");
  
      const formData = new FormData();
      formData.append("ImageUrl", jsonBlob, `${safeName}.json`);
      formData.append("UserId", sessionUserData?.Id);
      formData.append("OrgId", sessionUserData?.OrgId);
      formData.append("FileName", name);
  
      try {
        const response = await fetchWithAuth("file_upload/FlowChart", {
          method: "POST",
          body: formData,
        });
  
        const result = await response.json();
  
        if (!response.ok) {
          throw new Error(result?.Message || "Upload failed");
        }
  
        const fileName =
          result?.FileName ||
          result?.ResultData?.FileName ||
          result?.filename ||
          `${safeName}.json`;
  
        const fileUrl =
          result?.ImageUrl ||
          result?.ResultData?.ImageUrl ||
          result?.url ||
          null;
  
        setFiles((prev) =>
          prev.map((f) =>
            f.id === id
              ? {
                  ...f,
                  filename: fileName,
                  url: fileUrl,
                  updatedAt: Date.now(),
                }
              : f
          )
        );
        fetchBackendFiles();
  
        return result;
      } catch (err) {
        console.error("saveFileWithJson:", err);
        return null;
      }
    },
    [saveFile, sessionUserData]
  );
  /**
   * Fetches the .json file from the server URL and returns a complete file
   * object with nodes + connections populated.
   *
   * Called after saving (to refresh) or when the user picks a file.
   */
  const loadFileFromServer = useCallback(
    async (fileId) => {
      const existingFile = draftFiles.find(f => f.id === fileId);
      const fileUrl      = existingFile?.url;

      if (!fileUrl) {
        console.warn('loadFileFromServer: no url for fileId', fileId);
        return null;
      }

      try {
        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error(`Failed to fetch: ${fileUrl}`);

        const text    = await response.text();
        const diagram = parseDiagramJson(text);

        if (!diagram) throw new Error('Could not parse diagram JSON');

        const updatedFile = {
          ...existingFile,
          name        : diagram.name        || existingFile.name,
          nodes       : diagram.nodes       || [],
          connections : diagram.connections || [],
          updatedAt   : diagram.savedAt     || Date.now(),
        };

        setFiles((prev) =>
          prev.map((f) => (f.id === fileId ? updatedFile : f)),
        );
        setCurrentFileId(fileId);

        return updatedFile;
      } catch (err) {
        console.error('loadFileFromServer error:', err);
        return null;
      }
    },
    [files],
  );

  // ── FETCH file list from backend ───────────────────────────────────────────
  /**
   * Pulls the list of diagram files from the DDL endpoint and hydrates each
   * one by fetching its JSON file — so nodes/connections are always available.
   */
  // const fetchBackendFiles = useCallback(async () => {
  //   try {
  //     const response = await fetch(
  //       `${BASE_API}ADMINRoutes/CWIGetDDLItems?OrgId=8523&UserId=0`,
  //       { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  //     );
  //     if (!response.ok) throw new Error('Failed to fetch DDL items');

  //     const data = await response.json();

  //     // Filter to only .json flowchart files
  //     const flowChartItems = (data?.ResultData || []).filter(
  //       (item) =>
  //         `${item.DDLName || ''}`.toLowerCase().trim() === 'flowchart' &&
  //         `${item.ItemValue || ''}`.toLowerCase().endsWith('.json'),
  //     );

  //     // Build file stubs first (fast)
  //     const stubs = flowChartItems.map((item) => {
  //       const filename    = item.ItemValue.trim();
  //       const displayName = filename.replace(/^\d+-/, '').replace(/\.json$/i, '');
  //       const url         = `${JSON_BASE_URL}${encodeURIComponent(filename)}`;

  //       return {
  //         id          : `backend-${filename}`,
  //         name        : displayName,
  //         nodes       : [],
  //         connections : [],
  //         updatedAt   : Date.now(),
  //         filename,
  //         url,
  //         isBackend   : true,
  //         loaded      : false,   // mark as not-yet-hydrated
  //       };
  //     });

  //     // Merge stubs into state immediately so sidebar shows quickly
  //     setFiles((prev) => {
  //       const localFiles = prev.filter((f) => !f.isBackend);
  //       return [...stubs, ...localFiles];
  //     });

  //     // Hydrate each stub by fetching its JSON in parallel
  //     const hydrated = await Promise.all(
  //       stubs.map(async (stub) => {
  //         try {
  //           const res  = await fetch(stub.url);
  //           if (!res.ok) return stub;
  //           const text    = await res.text();
  //           const diagram = parseDiagramJson(text);
  //           if (!diagram) return stub;
  //           return {
  //             ...stub,
  //             name        : diagram.name        || stub.name,
  //             nodes       : diagram.nodes       || [],
  //             connections : diagram.connections || [],
  //             updatedAt   : diagram.savedAt     || stub.updatedAt,
  //             loaded      : true,
  //           };
  //         } catch {
  //           return stub;  // keep stub if fetch fails
  //         }
  //       }),
  //     );

  //     // Replace stubs with hydrated data
  //     setFiles((prev) => {
  //       const localFiles = prev.filter((f) => !f.isBackend);
  //       return [...hydrated, ...localFiles];
  //     });

  //     return hydrated;
  //   } catch (err) {
  //     console.error('fetchBackendFiles error:', err);
  //     return [];
  //   }
  // }, []);

  // ── public API ─────────────────────────────────────────────────────────────
  

const fetchBackendFiles = useCallback(async () => {
  try {
    const response = await fetchWithAuth(
      `KPI/MyDrafts?OrgId=${sessionUserData?.OrgId}&UserId=${sessionUserData?.Id}`,
      {
        method: "GET",
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.Message || "Failed to fetch drafts");
    }

    const drafts = data?.ResultData || [];

    const backendFiles = drafts.map((item) => ({
      id: item.Id,
      name: item.Filename,
      filename: item.FileUrl,
      url: `${BASE_DOCS_API_GET}${item.FileUrl}`,
      nodes: [],
      connections: [],
      updatedAt: Date.now(),
      isBackend: true,
      loaded: false,
      isBackendDraft: true,
    }));

    // Show files immediately
    setDraftFiles(backendFiles);

    // Download and parse each JSON
    const hydrated = await Promise.all(
      backendFiles.map(async (file) => {
        try {
          const res = await fetch(file.url);

          if (!res.ok) return file;

          const text = await res.text();
          const diagram = parseDiagramJson(text);

          if (!diagram) return file;

          return {
            ...file,
            name: diagram.name || file.name,
            nodes: diagram.nodes || [],
            connections: diagram.connections || [],
            updatedAt: diagram.savedAt || Date.now(),
            loaded: true,
          };
        } catch (err) {
          console.error("Failed to load:", file.url, err);
          return file;
        }
      })
    );

    setDraftFiles(hydrated);

    return hydrated;
  } catch (err) {
    console.error("fetchBackendFiles:", err);
    return [];
  }
}, [sessionUserData]);

const fetchEDMDocuments = useCallback(async (masterTypeId = 0) => {
  try {
    const url =
      `KPI/EDMflowCharts?OrgId=${sessionUserData?.OrgId}` +
      `&TypeId=${masterTypeId}`;

    const response = await fetchWithAuth(url, {
      method: "GET",
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result?.Message || "Failed to fetch documents");
    }

    const documents = (result?.ResultData || []).map((item) => ({
      id: item.Id,
      type: "document",
      name: item.DocName,
      filename: item.FileName,
      url: `${BASE_DOCS_API_GET}${item.FileUrl}`,
      uploadedOn: item.UploadedOn,
      uploadedBy: item.Name,
      shared: false,
      isBackend: true,
      loaded: true,
      isBackendDocument: true,
    }));

    setEdmDocuments(documents);

    return documents;
  } catch (err) {
    console.error("fetchEDMDocuments:", err);
    setEdmDocuments([]);
    return [];
  }
}, [sessionUserData]);

const loadDiagramFromUrl = useCallback(async (url) => {
  try {
      const response = await fetch(url);

      if (!response.ok) {
          throw new Error("Failed to fetch diagram");
      }

      const text = await response.text();
      const diagram = parseDiagramJson(text);

      return {
          name: diagram.name,
          nodes: diagram.nodes || [],
          connections: diagram.connections || [],
          updatedAt: diagram.savedAt || Date.now(),
      };
  } catch (err) {
      console.error(err);
      return null;
  }
}, []);

return {
  files,
  draftFiles,
  edmDocuments,
  loadDiagramFromUrl,

  currentFileId,
  setCurrentFileId,
  saveFile,
  saveFileWithPdf: saveFileWithJson,
  newFile,
  getFile,
  deleteFile,
  loadFileFromServer,
  fetchBackendFiles,
  fetchEDMDocuments,
  loadFileFromBackend: loadFileFromServer,
};
}
